import { render, staticRenderFns } from "./AdvertisementDetails.vue?vue&type=template&id=d61f51a6&scoped=true"
import script from "./AdvertisementDetails.vue?vue&type=script&lang=js"
export * from "./AdvertisementDetails.vue?vue&type=script&lang=js"
import style0 from "./AdvertisementDetails.vue?vue&type=style&index=0&id=d61f51a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d61f51a6",
  null
  
)

export default component.exports